module.exports = __webpack_public_path__ + "static/media/artist_11.534727e7.png";